import { NgModule, LOCALE_ID } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import localePT from '@angular/common/locales/pt';
import localeExtraPT from '@angular/common/locales/extra/pt';

import { TooltipModule } from 'primeng/tooltip';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { ToolbarModule } from 'primeng/toolbar';
import { DialogModule } from 'primeng/dialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import {FieldsetModule} from 'primeng/fieldset';
import { DropdownModule } from 'primeng/dropdown';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputMaskModule } from 'primeng/inputmask';
import { SelectButtonModule } from 'primeng/selectbutton';

import { SharedModule } from 'src/app/shared/shared.module';

import { EventoListComponent } from './evento-list/evento-list.component';
import { EventoDetalheComponent } from './evento-detalhe/evento-detalhe.component';
import { EventoDetalheDashboardComponent } from './evento-detalhe-dashboard/evento-detalhe-dashboard.component';
import { EventoDetalheFornecedorComponent } from './evento-detalhe-fornecedor/evento-detalhe-fornecedor.component';
import { EventoDetalheProdutoComponent } from './evento-detalhe-produto/evento-detalhe-produto.component';
import { ProgressBarModule } from 'primeng/progressbar';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { EventoPedidoListComponent } from './evento-pedido-list/evento-pedido-list.component';
import { EventoPedidoDetailComponent } from './evento-pedido-detail/evento-pedido-detail.component';
import { PainelModule } from 'src/app/shared/components/painel/painel.module';
import { ListboxModule } from 'primeng/listbox';
import { EventoPedidoDetalheComponent } from './evento-pedido-detalhe/evento-pedido-detalhe.component';
import { TabViewModule } from 'primeng/tabview';
import { TimelineModule } from 'primeng/timeline';
import { EventoPedidoPdfComponent } from './evento-pedido-pdf/evento-pedido-pdf.component';
import { DirectivesModule } from 'src/app/shared/directives/directives.module';
import { EventoProdutoImportarComponent } from './evento-produto-importar/evento-produto-importar.component';
import { EventoProdutoImportarLogComponent } from './evento-produto-importar-log/evento-produto-importar-log.component';
import { RouterModule } from '@angular/router';
import { FileUploadModule } from 'primeng/fileupload';
import { HttpClientModule } from '@angular/common/http';
import { CardModule } from 'src/app/shared/components/card/card.module';
import { NotificationsService } from 'src/app/shared/notifications/notifications.service';
import { RadioButtonModule } from 'primeng/radiobutton';
import {InputSwitchModule} from 'primeng/inputswitch';
import { VirtualScrollerModule } from 'primeng/virtualscroller';
import { NgxPrintModule } from 'ngx-print';





registerLocaleData(localePT, 'pt', localeExtraPT);

@NgModule({
  providers: [{provide: LOCALE_ID, useValue: 'pt-BR'}, NotificationsService],
  declarations: [EventoListComponent, EventoDetalheComponent, EventoDetalheDashboardComponent, 
    EventoDetalheFornecedorComponent, EventoDetalheProdutoComponent, EventoPedidoListComponent,
     EventoPedidoDetailComponent, EventoPedidoListComponent, EventoPedidoDetalheComponent, EventoPedidoPdfComponent, EventoProdutoImportarComponent, EventoProdutoImportarLogComponent],
  imports: [
    NgxPrintModule,
  TooltipModule,
    CommonModule,
    FormsModule,
    TableModule,
    ButtonModule,
    InputTextModule,
    ToolbarModule,
    DialogModule,
    ConfirmDialogModule,        
    BrowserModule,
    ToastModule,
    SharedModule,
    CalendarModule,
    CheckboxModule,
    ScrollPanelModule,
    FieldsetModule,
    DropdownModule,
    InputNumberModule,    
    InputMaskModule,
    SelectButtonModule ,
    ProgressBarModule ,
    PipesModule ,
    VirtualScrollerModule,
    PainelModule,
    ListboxModule,
    TabViewModule,
    TimelineModule,
    DirectivesModule,
    CalendarModule,
    RouterModule,
    FileUploadModule,
    HttpClientModule,
    CardModule,
    RadioButtonModule,
    InputSwitchModule
    
  ],
  exports: [EventoListComponent, EventoDetalheComponent, EventoDetalheProdutoComponent,EventoPedidoListComponent, EventoPedidoDetailComponent]
})
export class EventoModule { }